/**
 * Catalog of staff action slugs exposed by LMS module actions.
 * Slug strings must match the API exactly; add new entries here only.
 */
export const STAFF_PERMISSION = {
  dashboard: {
    graphTimeline: "dashboard.graph_timeline",
  },
  opportunity: {
    assignRm: "opportunity.assign_rm",
    convertToApplication: "opportunity.convert_to_application",
    createNewOpportunity: "opportunity.create_new_opportunity",
    creditBureauCheck: "opportunity.credit_bureau_check",
    edit: "opportunity.edit",
    followUp: "opportunity.follow_up",
    viewDetails: "opportunity.view_details",
    rejectOpportunity: "opportunity.reject_opportunity",
  },
  loanApplication: {
    assignRm: "loan_application.assign_rm",
    checkEligibilityDownload: "loan_application.check_eligibility_download",
    edit: "loan_application.edit",
    payment: "loan_application.payment",
    rejectApplication: "loan_application.reject_application",
    sendToQualityCheck: "loan_application.send_to_quality_check",
    viewDetails: "loan_application.view_details",
  },
  feesMaker: {
    create: "fees_maker.create", //
    editPayment: "fees_maker.edit_payment",
    viewDetails: "fees_maker.view_details", 
  },
  feesChecker: {
    approve: "fees_checker.approve",
    reject: "fees_checker.reject",
    viewDetails: "fees_checker.view_details",
  },
  qualityCheckCpa: {
    approve: "quality_check_cpa.approve",
    call: "quality_check_cpa.call",
    comments: "quality_check_cpa.comments",
    followUp: "quality_check_cpa.follow_up",
    mail: "quality_check_cpa.mail",
    viewApplication: "quality_check_cpa.view_application",
  },
  financialAnalysis: {
    call: "financial_analysis.call",
    edit: "financial_analysis.edit",
    followUp: "financial_analysis.follow_up",
    mail: "financial_analysis.mail",
    sendToCredit: "financial_analysis.send_to_credit",
    viewApplication: "financial_analysis.view_application",
  },
  initiation: {
    edit: "initiation.edit",
    legalInitiations: "initiation.legal_initiations",
    rcufcu: "initiation.rcufcu",
    technicalInitiations: "initiation.technical_initiations",
    view: "initiation.view",
  },
  capturing: {
    edit: "capturing.edit",
    legal: "capturing.legal",
    rcufcu: "capturing.rcufcu",
    technical: "capturing.technical",
    view: "capturing.view",
  },
  completion: {
    approve: "completion.approve",
    legalInitiation: "completion.legal_initiation",
    rcufcu: "completion.rcufcu",
    sendForCorrection: "completion.send_for_correction",
    technicalInitiation: "completion.technical_initiation",
  },
  underwriter: {
    approveApplication: "underwriter.approve_application",
    call: "underwriter.call",
    edit: "underwriter.edit",
    followUp: "underwriter.follow_up",
    forwardToCreditManager: "underwriter.forward_to_credit_manager",
    mail: "underwriter.mail",
    rejectApplication: "underwriter.reject_application",
    view: "underwriter.view",
  },
  postSanctionCases: {
    proceedWithSanctionedTerms:
      "post_sanction_cases.proceed_with_sanctioned_terms",
    raiseNegotiationRequest: "post_sanction_cases.raise_negotiation_request",
    sendToDisburse: "post_sanction_cases.send_to_disburse",
  },
  amendatorySanction: { //In this there will be module access permissions only
    respondToNegotiationRequests:
      "amendatory_sanction.respond_to_negotiation_requests",
    viewNegotiationRequests: "amendatory_sanction.view_negotiation_requests",
  },
  qualityCheckOperations: {
    approve: "quality_check_operations.approve",
  },
  disbursedCases: {
    disburse: "disbursed_cases.disburse",
    sendToBack: "disbursed_cases.send_to_back",
  },
} as const;

/** Module slugs from LMS staff permissions; must match `modules[].slugCode`. */
export const STAFF_MODULE = {
  dashboard: "dashboard",
  opportunity: "opportunity",
  loanApplication: "loan_application",
  feesMaker: "fees_maker",
  feesChecker: "fees_checker",
  qualityCheckCpa: "quality_check_cpa",
  financialAnalysis: "financial_analysis",
  initiation: "initiation",
  capturing: "capturing",
  completion: "completion",
  underwriter: "underwriter",
  postSanctionCases: "post_sanction_cases",
  amendatorySanction: "amendatory_sanction",
  qualityCheckOperations: "quality_check_operations",
  disbursedCases: "disbursed_cases",
} as const;

type StaffPermissionCatalog = typeof STAFF_PERMISSION;

/** Union of every catalogued slug, so unknown strings fail at compile time. */
export type StaffPermissionSlug = {
  [
    Module in keyof StaffPermissionCatalog
  ]: StaffPermissionCatalog[Module][keyof StaffPermissionCatalog[Module]];
}[keyof StaffPermissionCatalog];

export type StaffModuleSlug = (typeof STAFF_MODULE)[keyof typeof STAFF_MODULE];
